const priceFigure = x => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const isPositiveInteger = s => /^\+?[0-9][\d]*$/.test(s);


export {
  priceFigure, isPositiveInteger,
}
